export const BACKGROUND_URLS = [
  "/images/bg-cloud-1.svg",
  "/images/bg-cloud-2.svg",
  "/images/bg-cloud-3.svg",
]
